import { z } from "zod";

export const notificationTypeSchema = z.enum([
  "PATIENT_INVITE_ACCEPTED",
  "PARTNER_INVITE_ACCEPTED",
  "TEAM_INVITE_ACCEPTED",
  "TEAM_INVITE_RECEIVED",
  "SUPORTE_ACESSOU",
  "PRAZO_PROXIMO",
  "APPOINTMENT_CREATED",
  "APPOINTMENT_CANCELLED",
  "PROSTHESIS_LAB_CONNECTED",
  "PROSTHESIS_ORDER_RECEIVED",
  "PROSTHESIS_ORDER_UPDATED",
  "PROSTHESIS_REWORK_REQUESTED",
  "PARTNER_CONNECTED",
  "SYSTEM",
]);
export type NotificationType = z.infer<typeof notificationTypeSchema>;

/**
 * "ativa" é só a organização selecionada; "todas" junta todas as organizações em que a pessoa é
 * membro. O filtro por destinatário vale igual nos dois — "todas" não mostra nada que a pessoa não
 * pudesse ver trocando de organização, só poupa a troca.
 */
export const notificationEscopoSchema = z.enum(["ativa", "todas"]).default("ativa");

export const notificationListFiltersSchema = z.object({
  unreadOnly: z.boolean().default(false),
  take: z.number().int().min(1).max(100).default(20),
  skip: z.number().int().min(0).default(0),
  escopo: notificationEscopoSchema,
});
export type NotificationListFilters = z.infer<typeof notificationListFiltersSchema>;

// ─── Preferências por usuário ─────────────────────────────

export const notificationSoundSchema = z.enum([
  "none",
  "pop",
  "chime",
  "ding",
  "bell",
  "soft",
]);
export type NotificationSound = z.infer<typeof notificationSoundSchema>;

/** Canais de entrega — qual mídia o user quer receber pra cada tipo. */
export const channelPrefsSchema = z.object({
  platform: z.boolean().default(true),
  email: z.boolean().default(false),
  whatsapp: z.boolean().default(false),
});
export type ChannelPrefs = z.infer<typeof channelPrefsSchema>;

/** Preferências completas — shape armazenado em User.notificationPrefs. */
export const notificationPrefsSchema = z.object({
  soundEnabled: z.boolean().default(true),
  // partialRecord: no zod 4 o record com chave enum exige todas as chaves.
  perType: z
    .partialRecord(
      notificationTypeSchema,
      z.object({
        channels: channelPrefsSchema,
        sound: notificationSoundSchema,
      }),
    )
    .default({}),
});
export type NotificationPrefs = z.infer<typeof notificationPrefsSchema>;

/** Defaults aplicados quando user nunca salvou prefs. */
export const DEFAULT_NOTIFICATION_PREFS: NotificationPrefs = {
  soundEnabled: true,
  perType: {
    PATIENT_INVITE_ACCEPTED: {
      channels: { platform: true, email: false, whatsapp: false },
      sound: "chime",
    },
    PARTNER_INVITE_ACCEPTED: {
      channels: { platform: true, email: false, whatsapp: false },
      sound: "ding",
    },
    APPOINTMENT_CREATED: {
      channels: { platform: true, email: false, whatsapp: false },
      sound: "pop",
    },
    APPOINTMENT_CANCELLED: {
      channels: { platform: true, email: false, whatsapp: false },
      sound: "bell",
    },
    SYSTEM: {
      channels: { platform: true, email: false, whatsapp: false },
      sound: "soft",
    },
  },
};
